const list = (state) => {
  return state.list
}

const categoria = (state) => {
  return state.categoria
}

const dadosBasicos = (state) => {
  return state.dadosBasicos
}

const descricao = (state) => {
  return state.descricao
}

const linguaList = (state) => {
  return state.linguaList
}

const habilidadeList = (state) => {
  return state.habilidadeList
}

const certificacaoList = (state) => {
  return state.certificacaoList
}

const formacaoAcademicaList = (state) => {
  return state.formacaoAcademicaList
}

const historicoProfissionalList = (state) => {
  return state.historicoProfissionalList
}

const linguaGroup = (state) => {
  return state.linguaGroup
}

const habilidadeGroup = (state) => {
  return state.habilidadeGroup
}

const tipoEmpresa = (state) => {
  return state.tipoEmpresa
}

const ramoAtividade = (state) => {
  return state.ramoAtividade
}

const dadosBasicosValidation = (state) => {
  return state.dadosBasicosValidation
}
const descricaoValidation = (state) => {
  return state.descricaoValidation
}
const habilidadeListValidation = (state) => {
  return state.habilidadeListValidation
}

export default {
  list,
  categoria,
  dadosBasicos,
  descricao,
  linguaList,
  habilidadeList,
  certificacaoList,
  formacaoAcademicaList,
  historicoProfissionalList,
  linguaGroup,
  habilidadeGroup,
  tipoEmpresa,
  ramoAtividade,
  dadosBasicosValidation,
  descricaoValidation,
  habilidadeListValidation
}



// WEBPACK FOOTER //
// ./src/features/vp/curriculo/meusCurriculos/store/getters.js